require( 'Modernizr' );

import lazySizes from 'lazysizes';

lazySizes.cfg.loadMode = 1;
